import styled from 'styled-components';

const Button = styled.button`
  // Resets go here
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  text-rendering: inherit;
  letter-spacing: inherit;
  word-spacing: inherit;
  text-indent: inherit;
  text-shadow: inherit;
  text-align: inherit;
  align-items: inherit;
`;

// NOTE: this is intentionally a default export so that imports are readable,
// e.g. "import Button from 'src/components/Button'
export default Button;
